import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import Input from "../../../../ui/molecules/input"
import { GGNotificationMemberCreation, resetMemberCreationRequest, setMemberCreationAddress, setMemberCreationCompanyName, setMemberCreationCoopModule, setMemberCreationCropType, setMemberCreationDescription, setMemberCreationDestinationCountry, setMemberCreationGGN, setMemberCreationGGNotificationId, setMemberCreationGraspModule, setMemberCreationHarvestingPeriod, setMemberCreationLatitude, setMemberCreationLongitude, setMemberCreationManipulationType, setMemberCreationParallelProperty, setMemberCreationProduct, setMemberCreationSpringModule, setMemberCreationSubcontractedActivity, setMemberCreationSupervisor } from "./slice"
import { CustomRadio } from "../../../../ui/molecules/radioButton"
import { CropTypeEnum, GGManipulationEnum } from "../opzione1/dataservice/dto"
import { SingleCheckbox } from "../../../../ui/molecules/SingleCheckbox"
import Button from "../../../../ui/molecules/button"

interface Props {
    close: () => void
}

export function Option2Popup(props: Props) {
    const dispatch = useAppDispatch()
    const ggNotificationMemberState = useAppSelector(state => state.ggNotificationMember)
    const ggNotificationState = useAppSelector(state => state.ggNotification)
    const [cropType, setCropType] = useState<string | null>(null)
    const [manipulationType, setManipulationType] = useState<string | null>(null)
    const [parallelProperty, setParallelProperty] = useState<boolean>(false)
    const [COOP, setCOOP] = useState<boolean>(false)
    const [GRASP, setGRASP] = useState<boolean>(false)
    const [SPRING, setSPRING] = useState<boolean>(false)

    useEffect(() => {
        dispatch(setMemberCreationGGNotificationId(ggNotificationState.ggNotificationIdToUpdate))
    }, [])
    
    useEffect(() => {
        if(ggNotificationMemberState.memberCreationStatus === 'successfully') {
            dispatch(resetMemberCreationRequest())
            props.close()
        }
    }, [ggNotificationMemberState.memberCreationStatus])

    return (
        <div>
            <div className="bg-brandPrimary-100 pr-5 pl-5 pt-4 pb-5" style={{ borderTopWidth: 1 }}>

                <div className="pb-3" style={{ display: 'flex', gap: '24px', alignItems: 'center', borderBottom: '1px solid #d9e6e8' }}>
                    <div style={{ flex: '0.25' }}>
                        <Input
                            label={'GGN'}
                            placeholder="Specifica GGN..."
                            value={ggNotificationMemberState.memberCreationRequest.ggn}
                            onChangeText={(text) => dispatch(setMemberCreationGGN(text))}
                        />
                    </div>
                    <div style={{ flex: '0.25' }}>
                        <Input
                            label={'Ragione Sociale'}
                            placeholder="Specifica ragione sociale..."
                            value={ggNotificationMemberState.memberCreationRequest.companyName}
                            onChangeText={(text) => dispatch(setMemberCreationCompanyName(text))}
                        />
                    </div>
                    <div style={{ flex: '0.25' }}>
                        <Input
                            label={'Responsabile'}
                            placeholder="Specifica responsabile..."
                            value={ggNotificationMemberState.memberCreationRequest.supervisor}
                            onChangeText={(text) => dispatch(setMemberCreationSupervisor(text))}
                        />
                    </div>
                    <div style={{ flex: '0.25' }}>
                        <Input
                            label={'Indirizzo Sede Legale'}
                            placeholder="Specifica indirizzo sede legale..."
                            value={ggNotificationMemberState.memberCreationRequest.registeredOfficeAddress}
                            onChangeText={(text) => dispatch(setMemberCreationLongitude(text))}
                        />
                    </div>
                </div>

                <div className="text-left notify-subtitle pb-3 pt-3">
                    Sito Produttivo
                </div>

                <div className="pb-3" style={{ display: 'flex', gap: '24px', alignItems: 'center', borderBottom: '1px solid #d9e6e8' }}>
                    <div style={{ flex: '0.25' }}>
                        <Input
                            label={'Numero o descrizione'}
                            placeholder="Specifica numero o descrizione..."
                            value={ggNotificationMemberState.memberCreationRequest.description}
                            onChangeText={(text) => dispatch(setMemberCreationDescription(text))}
                        />
                    </div>
                    <div style={{ flex: '0.25' }}>
                        <Input
                            label={'Indirizzo'}
                            placeholder="Specifica indirizzo..."
                            value={ggNotificationMemberState.memberCreationRequest.address}
                            onChangeText={(text) => dispatch(setMemberCreationAddress(text))}
                        />
                    </div>
                    <div style={{ flex: '0.25' }}>
                        <Input
                            label={'Latitudine'}
                            placeholder="Specifica latitudine..."
                            value={ggNotificationMemberState.memberCreationRequest.latitude}
                            onChangeText={(text) => dispatch(setMemberCreationLatitude(text))}
                        />
                    </div>
                    <div style={{ flex: '0.25' }}>
                        <Input
                            label={'Longitudine'}
                            placeholder="Specifica longitudine..."
                            value={ggNotificationMemberState.memberCreationRequest.longitude}
                            onChangeText={(text) => dispatch(setMemberCreationLongitude(text))}
                        />
                    </div>
                </div>

                <div className="pb-3 pt-3" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.5' }}>
                        <Input
                            label={'Prodotto'}
                            placeholder="Specifica prodotto..."
                            value={ggNotificationMemberState.memberCreationRequest.product}
                            onChangeText={(text) => dispatch(setMemberCreationProduct(text))}
                        />
                    </div>
                    <div style={{ flex: '0.5' }}>
                        <Input
                            label={'Periodo Raccolta'}
                            placeholder="Specifica periodo..."
                            value={ggNotificationMemberState.memberCreationRequest.harvestingPeriod}
                            onChangeText={(text) => dispatch(setMemberCreationHarvestingPeriod(text))}
                        />
                    </div>
                </div>

                <div className="pb-3 pt-2" style={{ display: 'flex', gap: '12px', alignItems: 'center', borderBottom: '1px solid #d9e6e8' }}>
                    <span className='notify-text-bold'>
                        Tipologia Coltura
                    </span>
                    <div style={{ display: 'flex' }}>
                        <CustomRadio
                            options={[{ label: '', value: '1' }]}
                            selectedValue={cropType}
                            onChange={(value) => {
                                setCropType(value)
                                dispatch(setMemberCreationCropType(CropTypeEnum.PROTETTA))
                            }}
                            id={'crop1-new'}
                            name={'crop1-new'}
                        />
                        <div className='text-left'>
                            <span className='subtitle' style={{ color: '#5a8388' }}>Protetta (P)</span>
                        </div>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <CustomRadio
                            options={[{ label: '', value: '2' }]}
                            selectedValue={cropType}
                            onChange={(value) => {
                                setCropType(value)
                                dispatch(setMemberCreationCropType(CropTypeEnum.PIENO_CAMPO))
                            }}
                            id={'crop2-new'}
                            name={'crop2-new'}
                        />
                        <div className='text-left'>
                            <span className='subtitle' style={{ color: '#5a8388' }}>Pieno Campo (PC)</span>
                        </div>
                    </div>
                </div>

                <div className="text-left notify-subtitle pb-3 pt-3">
                    Manipolazione
                </div>

                <div className="pb-3" style={{ display: 'flex', gap: '48px', alignItems: 'center' }}>
                    <div>
                        <Input
                            label={'Attività subappaltate'}
                            placeholder="Specifica attività..."
                            value={ggNotificationMemberState.memberCreationRequest.subcontractedActivity}
                            onChangeText={(text) => dispatch(setMemberCreationSubcontractedActivity(text))}
                        />
                    </div>
                    <div className="mb-3" style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                        <span className='notify-text-bold'>
                            Tipologia Manipolazione
                        </span>
                        <div style={{ display: 'flex' }}>
                            <CustomRadio
                                options={[{ label: '', value: '2' }]}
                                selectedValue={manipulationType}
                                onChange={(value) => {
                                    setManipulationType(value)
                                    dispatch(setMemberCreationManipulationType(GGManipulationEnum.CAMPO))
                                }}
                                id={'man_type1'}
                                name={'man_type1'}
                            />
                            <div className='text-left'>
                                <span className='subtitle' style={{ color: '#5a8388' }}>Campo</span>
                            </div>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <CustomRadio
                                options={[{ label: '', value: '1' }]}
                                selectedValue={manipulationType}
                                onChange={(value) => {
                                    setManipulationType(value)
                                    dispatch(setMemberCreationManipulationType(GGManipulationEnum.MAGAZZINO))
                                }}
                                id={'man_type2'}
                                name={'man_type2'}
                            />
                            <div className='text-left'>
                                <span className='subtitle' style={{ color: '#5a8388' }}>Magazzino</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="pb-3 pt-3" style={{ display: 'flex', gap: '12px' }}>
                    <div style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                        <div className='text-left notify-text-bold'>
                            COOP ITALIA
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={COOP}
                            setChecked={(value) => {
                                dispatch(setMemberCreationCoopModule(value))
                                setCOOP(value)
                            }}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                        <div className='text-left notify-text-bold'>
                            GRASP
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={GRASP}
                            setChecked={(value) => {
                                dispatch(setMemberCreationGraspModule(value))
                                setGRASP(value)
                            }}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                        <div className='text-left notify-text-bold'>
                            COOP ITALIA
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={SPRING}
                            setChecked={(value) => {
                                dispatch(setMemberCreationSpringModule(value))
                                setSPRING(value)
                            }}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                        <div className='text-left notify-text-bold'>
                            Proprietà Parallela
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={parallelProperty}
                            setChecked={(value) => {
                                dispatch(setMemberCreationParallelProperty(value))
                                setParallelProperty(value)
                            }}
                        />
                    </div>
                </div>

                <div className="pb-3">
                    <Input
                        label={'Paese Destinazione'}
                        placeholder="Specifica paese..."
                        value={ggNotificationMemberState.memberCreationRequest.destinationCountry}
                        onChangeText={(text) => dispatch(setMemberCreationDestinationCountry(text))}
                    />
                </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', padding: 15, paddingRight: 15 }}>
                <Button
                    size="md"
                    variant="outline"
                    iconPosition="off"
                    label="Annulla"
                    color="dimgrey"
                    onClick={() => {
                        dispatch(resetMemberCreationRequest())
                        props.close();
                    }}
                />
                <div className="pl-2">
                    <Button
                        size="md"
                        variant="solid"
                        iconPosition="off"
                        label="Salva"
                        color="orange"
                        onClick={() => dispatch(GGNotificationMemberCreation(ggNotificationMemberState.memberCreationRequest))}
                    />
                </div>
            </div>
        </div>
    )
}